/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_General_Project_DescriptionInputs */



/**
* | output |
* | --- |
* | "Project Description" |
*
* @param {Options_General_Project_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_general_project_description = /** @type {((inputs?: Options_General_Project_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_General_Project_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Description du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektbeschreibung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizione del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Описание проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descripción del proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目描述")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトの説明")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परियोजना विवरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descrição do projeto")
	return /** @type {LocalizedString} */ ("Project Description")
});